<template>
  <div class="main">
    <div class="top_box">
      <DivTop :active='1'  />
      <div class="swiper-container yang">
        <div class="swiper-wrapper">
          <div class="swiper-slide back1">
              <div class="w120">
                <div class="content">
                    <span>专业智能化</span>
                    <span>软件系统提供商</span>
                    <span>领先于业界的先进科技产品，不断为客户提供更优化的产品体验；可覆盖多种场景，包括滑雪场、冰场、景区、演出场馆、餐厅、等可以应对多种复杂场景并保证使用体验。</span>
                </div>
              </div>
          </div>
          <div class="swiper-slide back2">
                <div class="w120">
                    <div class="contentTwo">
                      <span>金飞鹰生态运营管理模式</span>
                      <span>金飞鹰智能系统与各类场景深度融合，为您打造一个闭环的消费生态环境</span>
                      <div class="contentTwo_btns">
                        欢迎订购金飞鹰雪务通智能管理系统
                      </div>
                    </div>
                </div>
          </div>
          <div class="swiper-slide back3">
             <div class="w120">
              <div class="contentThree">
                  <span>完美体验</span>
                  <span>产品灵活 服务全程</span>
                  <span>金飞鹰十余年深厚技术积淀，为您量身打造符合自身特色的管理体系，降低运营成本，提升运维效率，使您更专注于核心业务创新。</span>
                </div>
             </div>   
          </div>
        </div>
        <div class="bottom_Carousel">
          <div :class="activeIndex=='0'?'wid77':''"> 
            <span>专业系统提供商</span>
          </div>
          <div :class="activeIndex=='1'?'wid77':''">
            <span>生态运营管理模式</span>
          </div>
          <div :class="activeIndex=='2'?'wid77':''">
            <span>领先业界新体验</span>
          </div>
        </div>
      </div>
      <div class="top_box_bjs">
        <vue-particles
            color="#00aeff"
            :particleOpacity="0.7"
            :particleOpacityRandom="true"
            :particlesNumber="140"
            shapeType="circle"
            :particleSize="4"
            linesColor="#8EB5C9"
            :linesWidth="1"
            :lineLinked="false"
            :lineOpacity="0.6"
            :linesDistance="120"
            :moveSpeed="1"
            :hoverEffect="false"
            hoverMode="grab"
            :clickEffect="false"
            clickMode="push"
        >
        </vue-particles>
      </div>
    </div>
    <div class="introduce ">
        <div class="w120">
            <div class="huanjing">
              <span>金飞鹰完善闭环运营生态环境</span>
              <img src="@/assets/nav.png" alt="" >
            </div>
            <span class="huan_txts">结合多种复杂场景在管理过程中的实际需求而设计研发的智能管理软件</span>
            <div class="intro_box">
              <img src="@/assets/center.png"  class="center_img" alt="">
                <div>
                  <div class="box_content">
                      <img src="@/assets/left.png" alt="">
                      <span>线下管理系统</span>
                      <div>
                          <div>收银管理</div>
                          <div>门禁管理</div>
                          <div>教学管理</div>
                          <div>器材租赁</div>
                          <div>自助机终端</div>
                          <div>商超管理</div>
                          <div>移动终端管理</div>
                          <div>餐饮管理</div>
                      </div>
                  </div>
                  <div class="box_content mar70">
                      <img src="@/assets/left.png" alt="">
                      <span>商家小程序</span>
                      <div>
                          <div>微信自营小程序</div>
                          <div>中国银行缤纷生活APP</div>
                          <div>云闪付APP</div>
                      </div>
                  </div>
                </div>
                <div>
                  <div class="box_content2">
                      <img src="@/assets/right.png" alt="">
                      <span>线上分销管理平台</span>
                      <div>
                          <div>景区管理</div>
                          <div>分销商管理</div>
                          <div>营销管理</div>
                          <div>教练预约</div>
                          <div>微餐饮</div>
                          <div>电子柜租赁</div>
                          <div>会员虚拟卡</div>
                      </div>
                  </div>
                  
                  <div class="box_content2 mar66">
                      <img src="@/assets/right1.png" alt="">
                      <span>智能设备</span>
                      <div>
                          <div>立式摆闸</div>
                          <div>远距摆闸</div>
                          <div>翼闸</div>
                          <div>三辊闸</div>
                          <div>自助售卖机</div>
                          <div>手持机</div>
                          <div>智能电子柜</div>
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <div class="whys">
      <div class="w120">
        <div class="why_top">
            <span>为什么选择金飞鹰</span>
            <img src="@/assets/nav.png" alt="">
        </div>
        <div class="why_duce">
          <span>业界领先技术</span>
          <span>服务稳定可靠</span>
          <span>系统服务安全</span>
          <span>坚定隐私承诺</span>
        </div>
        <div class="why_boxs">
          <div class="boxs_one">
            <span>自主研发</span>
            <div class="boxs_border">
                <img src="@/assets/index/one.png" alt="">
            </div>
            <div class="box_contents">
              对滑雪场的运营进行全面的剖析和量化处理，设计研发了中国第一套专业为冰雪场景管理服务的软件系统。
            </div>
          </div>
          <div class="boxs_two">
              <div class="boxs_contents">
                实现板鞋分离租借、计时点位自由设定、电子码套票、计次卡、自助购买、人脸识别、移动支付等体系等一系列运营措施在电子管理系统中的应用
              </div>
              <div class="boxs_two_border">
                  <img src="@/assets/index/two.png" alt="">
              </div>
              <span>智能领先者</span>
          </div>
          <div class="boxs_one">
            <span>最佳实践</span>
            <div class="boxs_border">
                <img src="@/assets/index/three.png" alt="">
            </div>
            <div class="box_contents">
              金飞鹰迄今为止服务过的滑雪场已经超过300家,是在中国滑雪行业用户认可程度最高的运营管理体系提供商
            </div>
          </div>
          <div class="boxs_two">
              <div class="boxs_contents">
                综合多家金飞鹰客户在运营中的经验，打造了金飞鹰行业管理共享体系，形成了“问题---讨论---思路---产品”研发模式；实现了线上分销与线下运营管理一体化的数据新格局，为冰场场景数字化营销提供有力的依据。
              </div>
              <div class="boxs_two_border">
                  <img src="@/assets/index/four.png" alt="">
              </div>
              <span>完善生态</span>
          </div>
        </div>
      </div>
    </div>
    <div class="date_boxs">
        <div class="w120">
          <span>金飞鹰创建历史</span>
          <div class="imgs">
            <img src="@/assets/nav.png" alt="">
          </div>
          <div class="date_duce">
            <div>
              <span>身份载体核验</span>
              <div>
                <span>3+</span><span>家</span>
              </div>
            </div>
            <div>
              <span>传统旅行社</span>
              <div>
                <span>14000+</span><span>家</span>
              </div>
            </div>
            <div>
              <span>在线分销商</span>
              <div>
                <span>290+</span><span>家</span>
              </div>
            </div>
            <div>
              <span>收单机构对接平台</span>
              <div>
                <span>20+</span><span>家</span>
              </div>
            </div>
          </div>
          <div class="swiper-container swiper2">
              <div class="swiper-wrapper date_boxw">
                  <div class="swiper-slide">
                    <span>北京金飞鹰科技发展有限公司成立</span>
                    <span>2005年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>实现门禁过门计时和客户种类判断；客户数量达到12家</span>
                    <span>2008年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>推出客房管理模块；客户数量超过20家</span>
                    <span>2009年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>推出第一代餐饮管理系统。此系统和雪场管理使用共同数据库</span>
                    <span>2010年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>推出第一代商店进销存管理系统；推出内部管理系统自助查询消费机</span>
                    <span>2011年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>金飞鹰的产品从单一的滑雪场管理系统逐步转型扩展为适应不同类型雪场需求的多模块组合型管理系统</span>
                    <span>2012年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>公司自主研发，嬉雪乐园产品实现第一代，带机站的手持移动终端</span>
                    <span>2013年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>设计规划互联网产品</span>
                    <span>2014年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>建立网络上传报表平台和雪场官网直销体系，客人通过自助机实现无人服务；金飞鹰票务销售平台和微信平台即将进入测试阶段</span>
                    <span>2015年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>完成第一代金飞鹰景区管理系统开发，实现了收费，结算，小交通等的业务处理</span>
                    <span>2016年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>主系统增加了微信和支付宝的支付方式。研制开发了升级版的门禁硬件产品，带有会员信息屏</span>
                    <span>2017年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>2.0版手持pda系统投入使用；金飞鹰自助机系列产品投产</span>
                    <span>2018年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>金飞鹰与阿里巴巴和中国银联建立合作关系，在大数据应用和移动支付应用中展开深度合作。为金飞鹰用户提供的微商城，小程序，微餐饮等平台也同时上线</span>
                    <span>2019年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>“冰雪乐园”小程序落户云闪付</span>
                    <span>2020年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>成立金飞鹰西南地区办事处；中国银联冰雪季活动成功举办</span>
                    <span>2021年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>手机端BOSS入口全面升级，增加数据分析和汇总
；云服务线上电子柜产品与线下数据报表全面合并；投资建立金飞鹰智能管理系统实训基地——金鹰冰场
</span>
                    <span>2022年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>2020--2023疫情期间，金飞鹰稳步发展，每年增加新客户10家以上；完善智慧收银台的各项功能
</span>
                    <span>2023年</span>
                  </div>
                  <div class="swiper-slide">
                    <span>继续前行
</span>
                    <span>2024年</span>
                  </div>
              </div>
          </div>
          <div class="swiper-button-prev rot" slot="button-prev">
              <img src="@/assets/index/right.png"/>
          </div>
          <div class="swiper-button-next rat" slot="button-next">
              <img src="@/assets/index/left.png"/>
          </div>
        </div>
    </div>
 
    <div class="ditu">
      <div id="particles" style="width:100%;height:35rem">
      </div>
      <div class="w120 center">
        <div class="ditu_text">
          <span>金飞鹰全国市场分布图</span>
          <img src="@/assets/nav.png" alt="">
          <span>北京金飞鹰科技是中国滑雪行业内用户认可度高的系统提供商</span>
        </div>
          <div class="dituLeft">
              <img src="@/assets/bottom.png" alt="" @click="TopClick">
              <div class="address">
                  <div  ref="content" :style="{ top:Top + 'px'}">
                    <span @click="swiperClick(index+1)" :class="index+1==addressIndex?'activecontent':''"  v-for="(item,index) in addres" :key="index">
                      {{item}}
                    </span> 
                  </div>
              </div>
              <img src="@/assets/top.png" alt="" class="Left_center"  @click="BottomClick">
          </div>
          <div class="right_ditu">
              <div class="ditu_imgs bj" v-if="addressIndex=='1'">
                <img src="@/assets/address/bj.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs hb" v-if="addressIndex=='2'">
                <img src="@/assets/address/hb.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs hlj" v-if="addressIndex=='3'">
                <img src="@/assets/address/hlj.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs xj" v-if="addressIndex=='4'">
                <img src="@/assets/address/xj.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs ln" v-if="addressIndex=='5'">
                <img src="@/assets/address/ln.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs jl" v-if="addressIndex=='6'">
                <img src="@/assets/address/jl.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs sx" v-if="addressIndex=='7'">
                <img src="@/assets/address/sx.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs sd" v-if="addressIndex=='8'">
                <img src="@/assets/address/sd.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs nmg" v-if="addressIndex=='9'">
                <img src="@/assets/address/nmg.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs nx" v-if="addressIndex=='10'">
                <img src="@/assets/address/nx.png" alt="">
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs sxx" v-if="addressIndex=='11'">
                <img src="@/assets/address/sxx.png" alt="">
                <div></div>
                <div></div><div></div><div></div><div></div><div></div><div></div>
              </div>
              <div class="ditu_imgs hn" v-if="addressIndex=='12'">
                <img src="@/assets/address/hn.png" alt="">
                <div></div><div></div><div></div><div></div><div></div><div></div><div></div>
              </div>
              <div class="ditu_imgs tj" v-if="addressIndex=='13'">
                <img src="@/assets/address/tj.png" alt="">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs cq" v-if="addressIndex=='14'">
                <img src="@/assets/address/cq.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs sc" v-if="addressIndex=='15'">
                <img src="@/assets/address/sc.png" alt="">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs hubei" v-if="addressIndex=='16'">
                <img src="@/assets/address/hubei.png" alt="">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs qh" v-if="addressIndex=='17'">
                <img src="@/assets/address/qh.png" alt="">
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs gs" v-if="addressIndex=='18'">
                <img src="@/assets/address/gs.png" alt="">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs hunan" v-if="addressIndex=='19'">
                <img src="@/assets/address/hunan.png" alt="">
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs gz" v-if="addressIndex=='20'">
                <img src="@/assets/address/gz.png" alt="">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs ah" v-if="addressIndex=='21'">
                <img src="@/assets/address/ah.png" alt="">
                <div></div>
                <div></div>
              </div>
              <div class="ditu_imgs yn" v-if="addressIndex=='22'">
                <img src="@/assets/address/yn.png" alt="">
                <div></div>
              </div>
              <div class="ditu_imgs gx" v-if="addressIndex=='23'">
                <img src="@/assets/address/gx.png" alt="">
                <div></div>
              </div>
          </div>
      </div>
    </div>
    <div class="cooperation">
      <div class="w120">
        <span>金飞鹰生态合作伙伴</span>
        <img src="@/assets/nav.png" alt="">
        <span>金飞鹰与多家合作伙伴共建更多满足客户营销需求，为客户创造更大的价值</span>
        <img src="@/assets/index/hezuo.png" alt="">
      </div>
    </div>
    <div class="service">
      <div class="w120">
        <span>金飞鹰生态合作伙伴</span>
        <img src="@/assets/nav.png" alt="">
        <span>金飞鹰技术专家为您提供24小时全程跟踪服务，实现360度无缝服务体系</span>
        <div class="service_box">
          <div>
            <img src="@/assets/index/blue.png" alt="">
            <span>现场实施</span>
            <span>技术经验丰富，操作流程规范有保障</span>
          </div>
          <div>
            <img src="@/assets/index/dlue.png" alt="">
            <span>电脑远程</span>
            <span>数据备份确认操作，最小授权操作</span>
          </div>
          <div>
            <img src="@/assets/index/blue.png" alt="">
            <span>电话客服</span>
            <span>24x7小时服务响应，快速完成服务交付</span>
          </div>
          <div>
            <img src="@/assets/index/dlue.png" alt="">
            <span>指导问题</span>
            <span>技术文档、视频帮助您快速解决</span>
          </div>
        </div>
        <div class="content_explain">
          <div>服务说明</div>
          <div>为了满足客户超出基础服务范围的诉求，服务仅包含专家服务费，不包含所需安装第三方软件的正版授权费用。</div>
        </div>
        <div class="content_three">
            <div class="three_left">
              服务定价
            </div>
            <div class="center_three">
              <div>
                约定的周期内，针对软件系统环境完成软件安装部署、异常排查、性能问题排查
              </div>
              <div>
                售后回访维护服务，终身软件升级
              </div>
              <div>
                每年进行线下面对面课程教学，全面培训一体化
              </div>
            </div>
            <div class="right_three">
              <div>免费</div>
              <div>免费</div>
              <div>免费</div>
            </div>
        </div>
      </div>
    </div>
    <Divfooter />
  </div>
</template>
<script>
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'
import particles from 'particles.js'
import particlesJson  from './particles.json'
export default {
  data(){
    return{
      activeIndex:0,
      addres:[
        '北京','河北','黑龙江','新疆','辽宁','吉林',"山西",'山东',
        '内蒙古','宁夏','陕西','河南','天津','重庆','四川','湖北','青海','甘肃','湖南','贵州','安徽','云南','广西'
      ],
      addressIndex:1,
      Top:0
    }
  },
  mounted() {
    let that = this
    new Swiper('.yang', {
      pagination: {
        el: '.swiper-pagination'
      },
      loop: this.loop,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false
      },
      on: {
        slideChangeTransitionEnd: function(){
            that.activeIndex = this.realIndex;
        },
      }
    })
    new Swiper ('.swiper2', {
      slidesPerView: 4,
      loop: true, // 循环模式选项
      pagination: {
        el: '.swiper-pagination.swiper1',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }) 
    particlesJS('particles', particlesJson,);
  },
  methods:{
    swiperClick(i){
      console.log(i,this.addressIndex)
      if(this.addressIndex==i){
        return false
      }
      this.addressIndex = i
    },
    TopClick(){
      if(this.Top==0){
        return false
      }
      this.$nextTick(function () {
        this.Top += 60
      })
    },
    BottomClick(){
      if(this.Top=='-540'){
        return false
      }
      this.$nextTick(function () {
        this.Top -= 60
      })
    },
  
  }
}
</script>
<style lang="less" scoped>
#particles{
  width: 100%;
  position: absolute;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.main{
  width: 100%;
  .top_box{
    width: 100%;
    height: 77rem;
    position: relative;
    .bottom_Carousel{
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 12rem;
      left: 50%;
      z-index: 99;
      transform: translate(-50%,0);
      >div{
        width: 20rem;
        padding-bottom: 1rem;
        border-bottom: 2px solid #959595;
        margin-right: 1.2rem;
        cursor: pointer;
        &:last-child{
          margin-right: 0;
        }
        span{
          color: #959595;
          font-size: 1.6rem;
        }
      }
      .wid77{
        border-color: #FFBD00;
        width: 77.6rem;
        span{
          color: #FFBD00;
        }
      }
    }
    .content{
      padding-top: 24.7rem;
      display: flex;
      flex-direction: column;
      >span{
        color: #fff;
        &:nth-child(1){
          font-size: 2.8rem;
        }
        &:nth-child(2){
          font-size: 4.6rem;
          margin-top: 1.6rem;
        }
        &:nth-child(3){
          width: 53rem;
          font-size: 1.6rem;
          margin-top: 1.6rem;
        }
      }
    }
    .contentTwo{
      padding: 27.7rem 0 0 0;
      box-sizing: border-box;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span{
        color: #fff;
        &:nth-child(1){
          font-size: 4.6rem;
        }
        &:nth-child(2){
          font-size: 1.6rem;
          margin-top: 1.6rem;
        }
      }
    }
    .contentThree{
      padding: 24.7rem 0 0 0 ;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span{
        color: #fff;
        &:nth-child(1){
          font-size: 2.8rem;
        }
        &:nth-child(2){
          color: #FFBD00;
          font-size: 4.6rem;
          margin-top: 1.6rem;
        }
        &:nth-child(3){
          font-size: 1.6rem;
          margin-top: 1.6rem;
          display: block;
          width: 53rem;
          text-align: center;
        }
      }
    }
  }
  .introduce{
      margin-top: -8rem;
      width: 100%;
      height: 84.6rem;
      background: url(../assets/huanjing.png) no-repeat;
      background-size: 100% 100%;
      padding-top: 12.9rem;
      .huanjing{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        span{
          font-size: 3.6rem;
          color: #fff;
        }
        img{
          width: 3.27rem;
          height: 1.69rem;
          margin-top: 0.7rem;
        }
      }
      .huan_txts{
        display:block;
        text-align: center;
        color: #fff;
        font-size: 2rem;
        margin-top: 2.1rem;
      }
      .intro_box{
        margin-top: 11.5rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .box_content{
          display: flex;
          flex-direction: column;
          width: 34rem;
          >img{
            width: 31.9rem;
            height: 1.4rem;
          }
          >span{
            font-size: 2rem;
            color: #fff;
            margin-top: 1.3rem;
          }
          >div{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            margin-top: 1rem;
            >div{
              margin-right: 1rem;
              padding: 0.2rem 1.2rem;
              box-sizing: border-box;
              background: #90A0B8;
              opacity: 0.6;
              border-radius: 0.6rem;
              color: #333B47;
              font-size: 1.6rem;
              margin-bottom: 1rem;
            }
          }
        }
        .box_content2{
          display: flex;
          flex-direction: column;
          width: 42.5rem;
          >img{
            width: 100%;
            height: 1.4rem;
          }
          >span{
            font-size: 2rem;
            color: #fff;
            margin-top: 1.3rem;
            text-align: right;
          }
          >div{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            margin-top: 1rem;
            >div{
              margin-left: 1rem;
              padding: 0.2rem 1.2rem;
              box-sizing: border-box;
              background: #90A0B8;
              opacity: 0.6;
              border-radius: 0.6rem;
              color: #333B47;
              font-size: 1.6rem;
              margin-bottom: 1rem;
            }
          }
        }
        .center_img{
          width: 53rem;
          height: 28.6rem;
          position: absolute;
          left: 49%;
          top: 32rem;
          transform: translate(-50%,0);
        }
      }
  }
  .whys{
    width: 100%;
    height:96rem;
    background: #F6F9FC;
    padding-top: 9.4rem;
    .why_top{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      span{
        font-size: 3.6rem;
        color: #333B47;
      }
      img{
        width: 3.27rem;
        height: 1.16rem;
        margin-top: 0.7rem;
      }
    }
    .why_duce{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 2rem;
      span{
        color: #333B47;
        font-size: 1.6rem;
        display: block;
        margin-right: 4.8rem;
      }
    }
    .why_boxs{
      display: flex;
      align-items: center;
      margin-top: 5.8rem;
      >div{
        width: 30rem;
        height: 60rem;
        background: #FFF;
        &:nth-child(2){
          background: #ECF2F8;
        }
        &:nth-child(4){
          background: #ECF2F8;
        }
      }
      .boxs_one{
        >span{
          color: #000000;
          font-size: 2.8rem;
          display: block;
          margin: 6rem 0 0 2rem;
        }
        .boxs_border{
          width: 26rem;
          height: 4.2rem;
          background: #FFBD00;
          position: relative;
          margin-top: 7rem;
          img{
            position: absolute;
            right: 1rem;
            width: 11.7rem;
            height: 14.2rem;
            top: -6rem;
          }
        }
        .box_contents{
          padding: 14.7rem 2rem 0 2rem;
          box-sizing: border-box;
          color: #666666;
          font-size: 1.6rem;
        }
      }
      .boxs_two{
        .boxs_contents{
          margin-top: 8rem;
          padding: 0 2rem 0 2rem;
          color: #666666;
          font-size: 1.6rem;
          width: 100%;
          height: 17rem;
        }
        .boxs_two_border{
          width: 26rem;
          height: 4.2rem;
          background: #FFBD00;
          position: relative;
          margin-top: 10rem;
          margin-left: auto;
          img{
            width: 16rem;
            height: 12.7rem;
            position: absolute;
            left: 1rem;
            top:-5rem;
          }
        }
        >span{
          color: #000000;
          font-size: 2.8rem;
          display: block;
          margin: 8.8rem 0 0 2rem;
        }
      }
    }
  }
  .date_boxs{
    width: 100%;
    background: url(../assets/date.png) no-repeat;
    background-size: 100% 100%;
    height: 60.6rem;
    padding-top: 9.4rem;
    box-sizing: border-box;

    >div{
      >span{
        color: #fff;
        font-size: 3.6rem;
        display: flex;
        justify-content: center;
      }
      .imgs{
        display: flex;
        margin-top: 1rem;
        justify-content: center;
        >img{
          width: 3.27rem;
          height: 1.169rem;
        }
      }
      .date_duce{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 2rem;
        >div{
          display: flex;
          flex-direction: column;
          margin-left: 4.8rem;
          >span{
            color: #fff;
            font-size: 1.6rem;
          }
          >div{
            margin-top: 1rem;
            span{
              color: #fff;
              font-size: 3.6rem;
              &:nth-child(2){
                font-size: 1.6rem;
              }
            }
          }
        }
      }
      .date_boxw{
        width: 100%;
        margin-top: 5.7rem;
  
        >div{
          height: 20rem;
          padding: 1rem 4.8rem 1rem 3rem;
          box-sizing: border-box;
          border-left: 4px solid #FFBD00;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          span{
            &:nth-child(1){
              color: #fff;
              font-size: 1.6rem;
            }
            &:nth-child(2){
              color:#FFBD00 ;
              font-size: 2.8rem;
            }
          }
        }
      }
    }
  }
  .ditu{
    height: 117rem;
    width: 100%;
    background: #070D2B;
    position: relative;
    z-index: 99;
    .ditu_text{
      position: absolute;
      left: 50%;
      transform: translate(-50%,0);
      top: 10rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      span{
        font-size: 3.6rem;
        color: #FFFFFF;
        &:nth-child(3){
          display: block;
          margin-top: 2rem;
          font-size: 1.6rem;
        }
      }
      img{
        width: 3.27rem;
        height: 1.16rem;
        margin-top: 0.7rem;
      }
    }
    .center{
      height: 100%;
      display: flex;
      align-items: center;

      .dituLeft{
        width: 6rem;
        height: 72.2rem;
        display: flex;
        flex-direction: column;
        position: relative;
        .address{
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          position: relative;
          div{
            width: 100%;
            height: 100rem;
            position: absolute;
            z-index: 999;
            span{
              color: #fff;
              font-size: 2rem;
              margin-bottom: 2.4rem;
              display: block;
              cursor: pointer;
            }
          }
         
        }
        img{
          position: absolute;
          cursor: pointer;
          width: 4rem;
          height: 2.4rem;
          &:nth-child(1){
            top: -4rem;
          }
        }
        .Left_center{
          bottom: -4rem;
        }
      }
      .right_ditu{
        width: 64.8rem;
        height: 64.8rem;
        background: url(../assets/address/yuan.png) no-repeat;
        background-size: 100%;
        position: absolute;
        top: 65%;
        left: 50%;
        transform: translate(-50%,-65%);
        .ditu_imgs{
          position: relative;
          >div{
            background: url(../assets/address/dian.png) no-repeat;
            background-size: 100%;
            width: 1.6rem;
            height: 1.6rem;
            position: absolute;
            animation: blink 1s infinite;
          }
          img{
            width: 100%;
            height: 100%;
          }
          @keyframes blink {
              0% { opacity: 1; } /* 图片完全显示 */
              30% { opacity: 0.5; } /* 图片完全显示 */
              50% { opacity: 0; } /* 图片隐藏 */
              75% { opacity: 0.5; } /* 图片隐藏 */
              100% { opacity: 1; } /* 图片完全显示 */
          }
        }
        .bj{
          width: 64.2rem;
          height: 66.5rem;
          >div{
            &:nth-child(2){
               top: 23.1rem;
               left: 18rem;
            }
            &:nth-child(3){
               top: 29rem;
               left: 35.7rem;
            }
            &:nth-child(4){
               top: 28.5rem;
               right: 18.8rem;
            }
            &:nth-child(5){
               bottom: 27.2rem;
               right:25.8rem;
            }
            &:nth-child(6){
               bottom: 19.5rem;
               left: 33.2rem;
            }
          }   
        }
        .hb{
          width: 50.1rem;
          height: 66.8rem;
          >div{
            &:nth-child(2){
              left: 9.7rem;
              top: 19rem;
            }
            &:nth-child(3){
              right: 11.5rem;
              top: 16.5rem;
            }
            &:nth-child(4){
              right: 11.5rem;
              top: 29.2rem;
            }
            &:nth-child(5){
              bottom: 25.8rem;
              left: 15rem;
            }
            &:nth-child(6){
              bottom: 20rem;
              left: 7rem;
            }
            &:nth-child(7){
              bottom: 4.7rem;
              left: 8.8rem;
            }
          }
        }
        .hlj{
          width: 82.7rem;
          height: 79.8rem;
          >div{
            &:nth-child(2){
              bottom: 18.3rem;
              left: 24.8rem;
            }
            &:nth-child(3){
              bottom: 15.4rem;
              left: 39.7rem;
            }
            &:nth-child(4){
              bottom: 9.3rem;
              right:24rem;
            }
            &:nth-child(5){
              bottom:19.9rem;
              right:13.5rem;
            }
          }
        }
        .xj{
          width: 77.6rem;
          height: 68.6rem;
          >div{
            &:nth-child(2){
              top: 6.3rem;
              left: 46.9rem;
            }
            &:nth-child(3){
              top: 16.4rem;
              left: 39.6rem;
            }
            &:nth-child(4){
              top: 22.8rem;
              right: 29.8rem;
            }
            &:nth-child(5){
              top: 25rem;
              right: 28.3rem;
            }
            &:nth-child(6){
              top: 27.2rem;
              right: 8.5rem;
            }
            &:nth-child(7){
              bottom: 25.6rem;
              right:31rem;
            }
            &:nth-child(8){
              bottom: 11.4rem;
              left:22.3rem;
            }
            &:nth-child(9){
              bottom: 29.4rem;
              left:24.8rem;
            }
          }
        }
        .ln{
          width: 80rem;
          height: 73.6rem;
          >div{
            &:nth-child(2){
              top: 22rem;
              left:31.5rem;
            }
            &:nth-child(3){
              right: 26rem;
              top: 26.5rem;
            }
            &:nth-child(4){
              right: 20rem;
              top: 24.7rem;
            }
            &:nth-child(5){
              right: 21.5rem;
              top: 32.2rem;
            }
            &:nth-child(6){
              left: 37.5rem;
              top: 36.2rem;
            }
            &:nth-child(7){
              left: 47rem;
              top: 36.6rem;
            }
            &:nth-child(8){
              left: 39.6rem;
              top:  43.6rem;
            }
          }
        }
        .jl{
          width: 84.6rem;
          height: 67.3rem;
          >div{
            &:nth-child(2){
              left: 32.3rem;
              top: 29.7rem;
            }
            &:nth-child(3){
              left:42.7rem;
              top: 30.6rem;
            }
            &:nth-child(4){
              right:15.2rem;
              top: 40.8rem;
            }
            &:nth-child(5){
              left:35.7rem;
              bottom: 9.3rem;
            }
            &:nth-child(6){
              right:41.5rem;
              bottom: 12.5rem;
            }
          }
        }
        .sx{
          width: 36rem;
          height: 63.9rem;
          >div{
            &:nth-child(2){
              top: 28.9rem;
              left: 18.8rem;
            }
            &:nth-child(3){
              left: 7.42rem;
              top: 33.4rem;
            }
            &:nth-child(4){
              right: 12.5rem;
              top: 31.2rem;
            }
            &:nth-child(5){
              bottom: 14.4rem;
              left: 10.3rem;
            }
            &:nth-child(6){
              right: 11rem;
              bottom: 16.4rem;
            }
            &:nth-child(7){
              left: 5.5rem;
              bottom: 4rem;
            }
          }
        }
        .sd{
          width: 79.6rem;
          height: 51.1rem;
          >div{
            &:nth-child(2){
              left: 20.5rem;
              top: 21rem;
            }
            &:nth-child(3){
              top: 19.2rem;
              left: 30.7rem;
            }
            &:nth-child(4){
              top: 18.4rem;
              left: 42.6rem;
            }
            &:nth-child(5){
              top: 8.2rem;
              right: 1.5rem;
            }
            &:nth-child(6){
              top: 24.8rem;
              right: 20.8rem;
            }
            &:nth-child(7){
              top: 28.8rem;
              left:22.1rem;
            }
            &:nth-child(8){
              bottom: 8.25rem;
              left: 36.9rem;
            }
            &:nth-child(9){
              right: 31.5rem;
              bottom: 12.1rem;
            }
          }
        }
        .nmg{
          width: 88.1rem;
          height: 63.5rem;
          >div{
            &:nth-child(2){
              top: 17.1rem;
              right: 18rem;
            }
            &:nth-child(3){
              top: 38.7rem;
              right: 28.5rem;
            }
            &:nth-child(4){
              bottom:15rem;
              right: 20.5rem;
            }
            &:nth-child(5){
              bottom:11.2rem;
              right: 39rem;
            }
            &:nth-child(6){
              bottom: 11.6rem;
              left: 42.6rem;
            }
            &:nth-child(7){
              bottom: 7.6rem;
              left: 37rem;
            }
            &:nth-child(8){
              bottom: 11.6rem;
              left: 37rem;
            }
          }
        }
        .nx{
          width: 48rem;
          height: 72.7rem;
          >div{
            &:nth-child(2){
              top: 15.2rem;
              left: 28.2rem;
            }
            &:nth-child(3){
              bottom: 13.8rem;
              left: 28.8rem;
            }
          }
        }
        .sxx{
          width: 41.2rem;
          height: 68.5rem;
          >div{
            &:nth-child(2){
              bottom: 29rem;
              left: 26.2rem;
            }
            &:nth-child(3){
              right: 9.8rem;
              bottom: 23.5rem;
            }
            &:nth-child(3){
              right: 16.9rem;
              bottom: 22.8rem;
            }
            &:nth-child(4){
              left: 12.3rem;
              bottom: 22.5rem;
            }
            &:nth-child(5){
              left: 10.7rem;
              bottom: 12.1rem;
            }   
            &:nth-child(6){
              right: 15.4rem;
              bottom: 20.6rem;
            }
            &:nth-child(7){
              right: 14.2rem;
              bottom: 8.3rem;
            }
            &:nth-child(8){
              right: 9.8rem;
              bottom: 23.5rem;
            }
          }
        }
        .hn{
          width: 63.5rem;
          height: 61.8rem;
          >div{
            &:nth-child(2){
              top: 1.8rem;
              left: 37.8rem;
            }
            &:nth-child(3){
              top: 6rem;
              right: 14.8rem;
            }
            &:nth-child(4){
              top:16.1rem;
              left: 27.4rem;
            }
            &:nth-child(5){
              top:20.4rem;
              left: 19.4rem;
            }
            &:nth-child(6){
              top:28.2rem;
              left: 34.4rem;
            }
            &:nth-child(7){
              top: 33.8rem;
              left: 23.3rem;
            }
            &:nth-child(8){
              top: 40rem;
              left: 22.2rem;
            }
          }
        }
        .tj{
          width: 43.7rem;
          height: 68rem;
          >div{
            &:nth-child(2){
              top: 6.4rem;
              left: 23rem;
            }
            &:nth-child(3){
              right: 6.7rem;
              top: 34.4rem;
            }
            &:nth-child(4){
              left: 15rem;
              bottom: 21.5rem;
            }
          }
        }
        .cq{
          width: 67.5rem;
          height: 66rem;
          >div{
            &:nth-child(2){
              left: 10.3rem;
              top: 36.9rem;
            }
            &:nth-child(3){
              right: 9.6rem;
              top: 17.8rem;
            }
            &:nth-child(4){
              left: 16.6rem;
              bottom: 22.6rem;
            }
            &:nth-child(5){
              left: 24.4rem;
              bottom: 15.9rem;
            }
          }
        }
        .sc{
          width: 71.6rem;
          height: 63.8rem;
          >div{
            &:nth-child(2){
              left: 30.9rem;
              top: 16.5rem;
            }
            &:nth-child(3){
              right: 15.9rem;
              top: 12.5rem;
            }
            &:nth-child(5){
              right: 4.8rem;
              top: 21.3rem;
            }
            &:nth-child(4){
              right: 27.7rem;
              top: 27rem;
            }
          }
        }
        .hubei{
          width: 86.7rem;
          height: 55.2rem;
          >div{
            &:nth-child(2){
              left: 18.5rem;
              top: 20rem;
            }
            &:nth-child(3){
              left: 40.3rem;
              top: 15.5rem;
            }
            &:nth-child(4){
              bottom: 20.7rem;
              left: 33.6rem;
            }
          }
        }
        .qh{
          width: 73.2rem;
          height: 52.9rem;
          >div{
            &:nth-child(2){
              right: 8.2rem;
              top: 13.1rem;
            }
            &:nth-child(3){
              right: 3.6rem;
              top: 16.1rem;
            }
          }
        }
        .gs{
          width: 78.3rem;
          height: 60.8rem;
          >div{
            &:nth-child(2){
              top: 22rem;
              left: 36.6rem;
            }
            &:nth-child(3){
              left: 54.2rem;
              bottom: 20.4rem;
            }
            &:nth-child(4){
              right: 25.7rem;
              bottom: 17.2rem;
            }
          }
        }
        .hunan{
          width: 57rem;
          height: 63.7rem;
          >div{
            &:nth-child(2){
              left: 17.1rem;
              top: 9.9rem;
            }
            &:nth-child(3){
              right: 11.7rem;
              top: 22.1rem;
            }
          }
        }
        .gz{
          width: 72.1rem;
          height: 57.8rem;
          >div{
            &:nth-child(2){
              top: 28rem;
              left: 13.1rem;
            }
            &:nth-child(3){
              right: 10.7rem;
              top: 20rem;
            }
            &:nth-child(4){
              bottom: 12.7rem;
              right: 13.8rem;
            }
          }
        }
        .ah{
          width: 46.9rem;
          height: 65.8rem;
          >div{
            &:nth-child(2){
              right: 12.2rem;
              top: 35.6rem;
            }
            &:nth-child(3){
              left: 17rem;
              bottom: 15.6rem;
            }
          }
        }
        .yn{
          width: 61rem;
          height: 64.7rem;
          >div{
            &:nth-child(2){
              top: 10.3rem;
              left: 14.8rem;
            }
          }
        }
        .gx{
          width: 81.9rem;
          height: 58.8rem;
          >div{
            &:nth-child(2){
              bottom: 13.8rem;
              right: 20.6rem;
            }
          }
        }
      }
    }
  }
  .cooperation{
    width: 100%;
    background: #F6F9FC;
    height: 85rem;
    >div{
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-top: 10rem;
      box-sizing: border-box;
      >span{
        color: #333B47;
        &:nth-child(1){
          font-size: 3.6rem;
        }
        &:nth-child(3){
          margin-top: 2rem;
          font-size: 1.6rem;
        }
      }
      img{
        &:nth-child(2){
          width: 3.27rem;
          height: 1.16rem;
          margin-top: 1rem;
        }
        &:nth-child(4){
          margin-top: 8rem;
        }
      }
    }
  }
  .service{
    width: 100%;
    background: #060B28;
    height: 88.6rem;
    >div{
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-top: 9.4rem;
      box-sizing: border-box;
      span{
        color: #FFF;
        font-size: 3.6rem;
        &:nth-child(3){
          font-size: 1.6rem;
          margin-top: 2rem;
          display: block;
        }
      }
      img{
          width: 3.27rem;
          height: 1.16rem;
          margin-top: 1rem;
      }
      .service_box{
        display: flex;
        align-items: center;
        margin-top: 6rem;
        justify-content: center;
        >div{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img{
            width: 8.2rem;
            height: 6.5rem;
          }
          span{
            color: #fff;
            font-size: 1.6rem;
            &:nth-child(2){
              margin-top: 2rem;
              display: block;
            }
          }
          &:nth-child(n+2){
            margin-left: 5rem;
          }
        }
      }
      .content_explain{
        width: 120rem;
        height: 8rem;
        display: flex;
        align-items: center;
        margin-top: 5.7rem;
        >div{
          background: url(../assets/index/bj.png) no-repeat;
          background-size: 100%;
          display: flex;
          color: #fff;
          font-size: 1.6rem;
          display: flex;
          align-items: center;
          &:nth-child(1){
            width: 15rem;
            height: 100%;
            justify-content: center;
            color: #FFBD00;
          }
          &:nth-child(2){
            border-left: 2px solid #060B28;
            flex: 1;
            height: 100%;
            padding:0 3rem ;
            box-sizing: border-box;
          }
        }
      }
      .content_three{
        width: 120rem;
        height: 24.4rem;
        margin-top: 0.2rem;
        display: flex;
        align-items: center;
        .three_left{
          display: flex;
          align-items: center;
          width: 15rem;
          height: 100%;
          justify-content: center;
          font-size: 1.6rem;
          color: #FFBD00;
          background: url(../assets/index/bj.png) no-repeat;
          background-size: 100% 100%;
        }
        .center_three{
          display: flex;
          flex-direction: column;
          margin-left: 0.2rem;
          >div{
            display: flex;
            align-items: center;
            width: 89.6rem;
            height: 8rem;
            font-size: 1.6rem;
            color: #FFF;
            padding: 0 3rem;
            box-sizing: border-box;
            background: url(../assets/index/bj.png) no-repeat;
            background-size: 100% 100%;
            margin-bottom: 0.2rem;
            &:last-child{
              margin-bottom: 0;
            }
          }
        }
        .right_three{
          display: flex;
          flex-direction: column;
          margin-left: 0.2rem;
          >div{
            display: flex;
            align-items: center;
            justify-content: center;
            width:15rem;
            height: 8rem;
            font-size: 1.6rem;
            color: #FFBD00;
            box-sizing: border-box;
            background: url(../assets/index/bj.png) no-repeat;
            background-size: 100% 100%;
            margin-bottom: 0.2rem;
            &:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
    }

  }
}
.mar70{
  margin-top: 7rem;
}
.mar66{
  margin-top: 6.6rem;
  width: 33.4rem !important;
  margin-left: auto;
}
.back1{
  background: url(../assets/index1.png) no-repeat;
  background-size: 100% 100%;
}
.back2{
  background: url(../assets/index2.png) no-repeat;
  background-size: 100% 100%;
}
.back3{
  background: url(../assets/index3.png) no-repeat;
  background-size: 100% 100%;
}
.swiper-container {
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper-pagination-bullet-active {
  background: #007aff;
}
::v-deep .rat::after, ::v-deep .rot::after{
  display: none;
}
.rat,.rot{
  top: 0;
}
.top_box_bjs{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
}
.activecontent{
  color: #246DEB !important;
}
.contentTwo_btns{
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 0.4rem;
  width: 28rem;
  box-sizing: border-box;
  background: #246DEB;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  font-size: 1.6rem;
}
</style>
